// base
import { useState } from 'react';

// hooks
import { useAlarm } from 'hooks';

// modules
import { type ResultError } from 'modules';

/**
 * 공통 훅: 비동기 함수를 callAsync로 감싸며, 로딩/에러 처리
 */
export const useAsync = () => {
  const [loading, setLoading] = useState(false);

  const { showAlarm, closeAlarm } = useAlarm();

  /**
   * callAsync: 원하는 시점에, 원하는 비동기 함수를 넘겨 호출할 수 있도록 함
   * - 제네릭 <T>는 호출부에서 반환할 데이터 타입을 유추
   * - fn은 "실제 비동기 함수(API 등)를 실행"하는 콜백
   */
  const callAsync = async <T>(promise: Promise<T>) => {
    setLoading(true);

    try {
      await promise;
      return true;
    } catch (error) {
      const err = error as ResultError;

      showAlarm({
        message: err.message,
        modalTitle: 'Error',
        noFooter: false,
        isSingleFooter: true,
        closeButtonProps: {
          onClick: closeAlarm
        }
      });

      return false;
    } finally {
      setLoading(false);
    }
  };

  return { callAsync, loading, showAlarm, closeAlarm };
};
